export interface HandlingWarningsValue {
  fragile: boolean;
  heavy: boolean;
  keep_upright: boolean;
  do_not_stack: boolean;
  temperature_sensitive: boolean;
  lithium_batteries: boolean;
}

export const handlingWarningOptions: Array<{
  field: keyof HandlingWarningsValue;
  label: string;
}> = [
  { field: "fragile", label: "Fragile" },
  { field: "heavy", label: "Heavy" },
  { field: "keep_upright", label: "Keep upright" },
  { field: "do_not_stack", label: "Do not stack" },
  { field: "temperature_sensitive", label: "Temperature sensitive" },
  { field: "lithium_batteries", label: "Lithium batteries" }
];

export function HandlingWarningFields({
  value,
  onChange
}: {
  value: HandlingWarningsValue;
  onChange: (field: keyof HandlingWarningsValue, checked: boolean) => void;
}) {
  return (
    <fieldset>
      <legend>Handling warnings</legend>
      <div className="choice-grid">
        {handlingWarningOptions.map(({ field, label }) => (
          <label className="large-check" key={field}>
            <input
              type="checkbox"
              checked={value[field]}
              onChange={(event) => onChange(field, event.target.checked)}
            />
            {label}
          </label>
        ))}
      </div>
    </fieldset>
  );
}
